export const deliveryOptions = [
  { value: 'pickup', label: 'EditListingLocationForm.pickupLabel' },
  { value: 'dropoff', label: 'EditListingLocationForm.shippingLabel' },
  { value: 'courier', label: 'EditListingLocationForm.courierLabel' },
];
